<template>
	<tr
		class="ms-tr"
		tabindex="0"
		@keydown="row_keydown"
		:class="dataRow.isSelected ? 'ms-tr-hover' : ''"
	>
		<td v-if="serial" class="ms-td serial text-center">
			{{ pageSize * (currentPage - 1) + rowIndex + 1 }}
		</td>
		<td v-if="multiple" class="ms-td multiple-cell">
			<ms-checkbox
				:checked="isSelected"
				class="center"
				ref="multiple"
				checkOnly
				@click="checkMultiple"
			/>
		</td>
		<td
			v-for="(col, colIndex) in columns"
			:key="col.dataField"
			class="ms-td"
			@click="cell_click(col, colIndex)"
			@dblclick="cell_dblclick"
			:style="styleWidth(col)"
		>
			<component
				:is="col.template"
				:data="dataRow"
				:column="col"
				v-if="col.template"
				v-bind="col.templateProps"
				v-on="col.templateEvent"
			></component>
			<!-- <div
				class="flex"
				:class="[`justify-center`, col.cssClass]"
				v-else-if="col.isSerial"
			>
				<span>{{ index + 1 }}</span>
			</div> -->
			<div v-else-if="col.isHtmlText" v-html="dataRow[col.dataField]"></div>
			<div
				class="flex items-center"
				:class="[
					`justify-${col.align == 'right' ? 'end' : col.align}`,
					col.cssClass,
				]"
				v-else
			>
				<span
					:class="[`text-${col.align}`, `text-line-${col.maxLine}`]"
					:ref="`text-${col.dataField}`"
					@click="
						typeof col.drilldown == 'function' ? col.drilldown(dataRow) : null
					"
					v-tooltip="
						typeof col.tooltipCustom == 'function'
							? col.tooltipCustom(dataRow)
							: null
					"
					>{{
						getDeepData(dataRow, col.dataField)
							| formatData({
								formatType: col.formatType,
								enumName: col.enumName,
								dataRow: dataRow,
								...col.formatOptions,
							})
					}}</span
				>
			</div>
			<!-- <component
				:is="getEditorType(col)"
				:ref="`editor-${colIndex}`"
				:col="col"
				:dataRow="dataRow"
				:rowIndex="rowIndex"
				:colIndex="colIndex"
				:editable="editable"
				:rowSelected="rowSelected"
				:disabledLst="disabledLst"
				:isBlurAction="isBlurAction"
				v-on="listeners"
			></component> -->
		</td>
		<td
			v-if="widgetOptions"
			class="ms-td widget-item"
			:style="styleWidth(widgetOptions)"
			:class="widgetOptions.class"
		>
			<component
				:is="widgetOptions.components"
				:dataRow="dataRow"
				@widgetEvent="widgetEvent"
				:rowIndex="rowIndex"
				:isSelected="isSelected"
			></component>
		</td>
	</tr>
</template>
<script>
import msCellInputV2 from './mscell-editor-v2/msCellInputV2.vue';
import msCellCombobox from './mscelleditor/msCellCombobox.vue';
import msCellComboboxWithDifferentValue from './mscelleditor/msCellComboboxWithDifferentValue.vue';
import msCellNumber from './mscelleditor/msCellNumber.vue';
import msCellCheckbox from './mscelleditor/msCellCheckbox.vue';
import msCellDatepicker from './mscelleditor/msCellDatepicker.vue';
import msCellDropdown from './mscelleditor/msCellDropdown.vue';
export default {
	name: 'msTrV3',
	props: {
		//Lưu thông tin của các cột
		columns: {},
		//Lưu dữ liệu của dòng
		dataRow: {},
		//Lưu cấu hình của cột chức năng
		widgetOptions: {},
		//Ẩn/hiện cột checkbox tích chọn nhiều cột
		multiple: {
			default: false,
			type: Boolean,
		},
		rowIndex: {
			default: 0,
			type: Number,
		},
		//Trạng thái tích chọn ở cột multiple
		isSelected: {
			default: false,
			type: Boolean,
		},
		//Thuộc tính cấu hình hiện thị cột STT
		serial: {
			default: false,
			type: Boolean,
		},
		//Thuộc tính để cấu hình cho phép sửa trên grid hay không
		editable: {
			default: true,
			type: Boolean,
		},
		rowSelected: {
			default: null,
		},
		disabledLst: [],
		isHoverTr: {
			default: true,
			type: Boolean,
		},
		/**
		 * Sửa cell trên table bằng sự kiện của grid
		 */
		editableByRowAction: {
			default: false,
			type: Boolean,
		},
		isBlurAction: {
			default: true,
			type: Boolean,
		},
		isHasSelected: {
			default: false,
			type: Boolean,
		},
		currentPage: {
			default: 1,
			type: Number,
		},
		pageSize: {
			default: 20,
			type: Number,
		},
	},
	components: {
		msCellInputV2,
		msCellCombobox,
		msCellNumber,
		msCellCheckbox,
		msCellDatepicker,
		msCellDropdown,
		msCellComboboxWithDifferentValue,
	},
	computed: {
		listeners() {
			const me = this;
			return {
				selected: (metaData) => {
					metaData.rowIndex = me.rowIndex;
					me.$emit('selected', metaData);
				},
				change: (metaData) => {
					metaData.rowIndex = me.rowIndex;
					me.$emit('change', metaData);
				},
				rowSelected: (data) => {
					data.rowIndex = me.rowIndex;
					me.$emit('rowSelected', data);
				},
				loadDataCombo: (metaData) => {
					metaData.rowIndex = me.rowIndex;
					me.$emit('loadDataCombo', metaData);
				},
				blur: (metaData) => {
					metaData.rowIndex = me.rowIndex;
					me.$emit('blur', metaData);
				},
				next: () => {
					let data = { rowIndex: me.rowIndex };
					me.$emit('next', data);
				},
			};
		},
	},
	methods: {
		testRender() {},
		//Cập nhật lại width cho cell khi width của col bị thay đổi
		//Created by LTDAT (30.06.2020)
		styleWidth(col) {
			const me = this;
			if (col.autoResize) {
				return { 'min-width': `${col.width}px` };
			} else {
				return { width: `${col.width}px`, 'min-width': `${col.width}px` };
			}
		},
		//Lấy lại control editor
		//Created by LTDAT (17.06.2020)
		getEditorType(col) {
			const me = this;
			switch (col.columnType) {
				case 'combobox':
					return 'msCellCombobox';
					break;
				case 'input':
					return 'msCellInputV2';
					break;
				case 'number':
					return 'msCellNumber';
					break;
				case 'checkbox':
					return 'msCellCheckbox';
					break;
				case 'datepicker':
					return 'msCellDatepicker';
					break;
				case 'dropdown':
					return 'msCellDropdown';
					break;
				case 'comboboxDifferentValue':
					return 'msCellComboboxWithDifferentValue';
					break;
				case 'template':
					return col.template;
					break;
				default:
					return 'msCellInputV2';
					break;
			}
		},
		//Emit sự kiện từ widget ra ngoài
		// Created by LTDAT (16.06.2020)
		widgetEvent(data, event) {
			const me = this;
			if (data) {
				data.rowIndex = me.rowIndex;
			}
			// if (me.editableByRowAction) {
			// 	let editor = me.$refs[`editor-${0}`];
			// 	data.editor = editor[0];
			// }
			me.$emit('widgetEvent', data, event);
		},
		//Emit sự kiện click row ra ngoài grid
		//Created by LTDAT(13/06/2020)
		cell_click(col, colIndex) {
			const me = this;
			// let editor = me.$refs[`editor-${colIndex}`];
			// me.$emit('click', editor[0]);
		},
		//Emit sự kiện dblclickRow ra ngoài grid
		//Created by LTDAT(13/06/2020)
		cell_dblclick(e) {
			const me = this;
			let dataRow = { ...me.dataRow, rowIndex: me.rowIndex };
			me.$emit('dblclick', dataRow, e);
		},
		//Emit sự kiện ấn phím ra ngoài grid
		//Created by LTDAT(13/06/2020)
		row_keydown(e) {
			const me = this;
			let dataRow = { ...me.dataRow, rowIndex: me.rowIndex };

			// if (me.editableByRowAction) {
			// 	let editor = me.$refs[`editor-${0}`];
			// 	dataRow.editor = editor[0];
			// }
			me.$emit('keydown', dataRow, e);
		},
		//Sự kiện click vào nút chọn ở cột multiple
		//Created by LTDAT (28.05.2020)
		checkMultiple(event) {
			const me = this;
			let dataRow = { ...me.dataRow, rowIndex: me.rowIndex };
			me.$emit('clickMultiple', dataRow);
		},
		getDeepData(data, dataField) {
			//Trả về trực tiếp trường
			if (!dataField || !dataField.includes('.')) return data[dataField];

			//Nếu dataField có dấu . sẽ gọi lần lượt tới các cấp sâu hơn trong object
			dataField = dataField.split('.');
			dataField.forEach((item) => {
				if (!data) return '';
				data = data[item] || '';
			});
			return data;
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msTrViewer.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msTrViewer.scss';
}
.ms-tr {
	position: relative;
	.widget-item {
		position: absolute;
		right: 0;
		display: none;
	}
}
.ms-tr:hover {
	.ms-td:last-child {
		border: none;
	}
	.widget-item {
		display: block;
	}
}
</style>